export enum CiIntegrationProviders {
	JENKINS = 'JENKINS',
}
